import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import BottomNav from "@/components/BottomNav";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Today from "@/pages/Today";
import Chat from "@/pages/Chat";
import Connections from "@/pages/Connections";
import Profile from "@/pages/Profile";
import Premium from "@/pages/Premium";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import { Toaster } from "sonner";

function Shell({ children }) {
  return (
    <div className="app-shell flex flex-col">
      <div className="flex-1 flex flex-col">{children}</div>
      <BottomNav />
    </div>
  );
}

function RootRedirect() {
  const { user, ready } = useAuth();
  if (!ready) return null;
  return <Navigate to={user ? "/today" : "/welcome"} replace />;
}

export default function App() {
  return (
    <AuthProvider>
      <Toaster position="top-center" richColors />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<RootRedirect />} />
          <Route path="/welcome" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/premium" element={<ProtectedRoute><Shell><Premium /></Shell></ProtectedRoute>} />
          <Route path="/payment/success" element={<ProtectedRoute><PaymentSuccess /></ProtectedRoute>} />
          <Route path="/payment/cancel" element={<ProtectedRoute><PaymentCancel /></ProtectedRoute>} />
          <Route path="/today" element={<ProtectedRoute><Shell><Today /></Shell></ProtectedRoute>} />
          <Route path="/chat/:matchId" element={<ProtectedRoute><Shell><Chat /></Shell></ProtectedRoute>} />
          <Route path="/connections" element={<ProtectedRoute><Shell><Connections /></Shell></ProtectedRoute>} />
          <Route path="/profile" element={<ProtectedRoute><Shell><Profile /></Shell></ProtectedRoute>} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
